import Base from "./Base";

class Items extends Base {

    static getUserLists(params) {
        return this.sendRequest('/items/get-user-lists', 'GET', params);
    }

    static getUsersList() {
        return this.sendRequest('/items/get-users-list', 'GET');
    }

    static getAllItems() {
        return this.sendRequest('/items/get-all-items', 'POST')
    }
}

export default Items;

// TL.ApiClient.Invite = new Invite();
